import React from 'react';

import {SettingIndentedRow} from '../../components/SettingIndentedRow';
import {CompareControl} from '../common/CompareControl';
import {SettingTitle} from '../common/SettingTitle';

export const CompareControls = () => {
  return (
    <div className="flex flex-col">
      <SettingTitle
        title="Variable controls"
        description="Define how each of the following variables is applied across tiles."
      />
      <SettingIndentedRow className="gap-12 mt-4">
        <CompareControl
          field="mediaKey"
          label="Media key"
          aria-label="Media key tile control"
        />
        <CompareControl field="run" label="Run" aria-label="Run tile control" />
        <CompareControl
          field="step"
          label="Step"
          aria-label="Step tile control"
        />
        <CompareControl
          field="index"
          label="Index"
          aria-label="Index tile control"
        />
      </SettingIndentedRow>
    </div>
  );
};
